/**
 * Primary → derived stat coefficients. `calculateDerivedStats` (CombatLogic.ts)
 * computes with these and the character sheet's formula text
 * (`ui/Systems/Character/Stats/StatHelpers.ts`) prints them, so the two cannot
 * drift apart. Change a number here and both move together.
 */
export const DERIVED_STAT_COEFFICIENTS = {
  /** ATK: STR-scaling classes use `str`; DEX-scaling classes `dexClassStr` + `dexClassDex`; classless fixtures `classlessStr`. */
  attack: { str: 2.5, dexClassStr: 1, dexClassDex: 2.5, classlessStr: 2 },
  /** MATK: INT-scaling (caster) classes vs everyone else. */
  magicAttack: { casterInt: 2.5, otherInt: 2 },
  defense: { dex: 2 },
  magicDefense: { luk: 2 },
  accuracy: { dex: 0.8, luk: 0.5 },
  avoidability: { luk: 0.5, dex: 0.2 },
  /** Percent. DEX-scaling classes also gain `dexClassDex` per DEX. */
  criticalRate: { base: 5, luk: 0.1, dexClassDex: 0.1 },
  speed: { base: 100, dex: 0.05 },
  jump: { base: 100, str: 0.02, dex: 0.02 },
} as const;

/** Classes whose physical attack and crit scale with DEX. */
export const DEX_SCALING_CLASSES: readonly string[] = ['hunter', 'rogue'];
/** Classes whose magic attack uses the caster multiplier. */
export const INT_SCALING_CLASSES: readonly string[] = ['mage', 'shaman', 'priest', 'warlock', 'druid'];

export const isDexScalingClass = (cls?: string): boolean => DEX_SCALING_CLASSES.includes(cls ?? '');
export const isIntScalingClass = (cls?: string): boolean => INT_SCALING_CLASSES.includes(cls ?? '');
